{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Crown Land Header",
      "width": 185,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "agreement_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Title/Agreement No.",
      "folder": "Crown Land Header",
      "width": 150,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "agreement_type_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement Type ID",
      "folder": "Crown Land Header",
      "tnum": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "tract": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Tract",
      "folder": "Crown Land Header",
      "width": 75,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Crown Land Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "land_ids": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land IDs",
      "folder": "Crown Land Header",
      "width": 175,
      "isShownByDefault": true,
      "isNotSortable": true,
      "tnum": true,
    },
    "gpt": {
      "hint": "Comma-separated land IDs in DLS/ATS/NTS format (e.g. T035R19W3S11A, T027R28W4S01L14, P093HIS14BJU076)",
    },
  },
  "zone_description": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Zone Description",
      "folder": "Crown Land Header",
      "width": 250,
      "isShownByDefault": true,
    },
  },
  "agreement_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement Type",
      "folder": "Crown Land Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "pn_agreement_type": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "PNG",
        "OS",
        "Coal",
        "Metal",
        "Geothermal",
        "CO2",
        "Helium",
        "Brine",
      ],
    },
    "ui": {
      "label": "Stack Maps Agreement Type",
      "folder": "Crown Land Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "participants": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Owner",
      "folder": "Crown Land Header",
      "width": 250,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this field by default when a company name is mentioned",
    },
  },
  "designated_rep": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Designated Rep",
      "folder": "Crown Land Header",
      "width": 250,
    },
    "gpt": {
      "hint": "Default to 'participants' unless designated rep is explicitly mentioned",
    },
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "folder": "Crown Land Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "issue_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Issue Date",
      "folder": "Crown Land Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "folder": "Crown Land Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "earliest_continued_to_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Earliest Continued To Date",
      "folder": "Crown Land Header",
    },
  },
  "section_of_act": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Section of Act",
      "folder": "Crown Land Header",
    },
  },
  "area": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area",
      "folder": "Crown Land Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "bonus": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2,
    },
    "ui": {
      "label": "Bonus",
      "folder": "Crown Land Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "bonus_per_area": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$",
      "fractionDigits": 2,
    },
    "ui": {
      "label": "Bonus/Area",
      "folder": "Crown Land Header",
      "width": 115,
      "isShownByDefault": true,
    },
  },
  "term_length": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Term Length",
      "folder": "Crown Land Header",
    },
  },
  "continuation_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Continuation Date",
      "folder": "Crown Land Header",
    },
  },
  "cancellation_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Cancellation Date",
      "folder": "Crown Land Header",
    },
  },
  "rental_default_notice_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Rental Default Notice Date",
      "folder": "Crown Land Header",
    },
  },
  "default_notice_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Default Notice Type",
      "tooltip": "Excludes Rental Default notices",
      "folder": "Crown Land Header",
      "subFolder": "AB Header",
    },
  },
  "default_notice_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Default Notice Date",
      "tooltip": "Excludes Rental Default notices",
      "folder": "Crown Land Header",
      "subFolder": "AB Header",
    },
  },
  "offset_compensation_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Offset Compensation",
      "folder": "Crown Land Header",
      "subFolder": "AB Header",
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
